import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { RenewalRoutingModule } from './renewal-routing.module';
import { SharedModule } from '../shared/shared.module';
import { RenewalComponent } from './renewal.component';
import { MotorStepComponent } from './motor-step/motor-step.component';
import { MotorDetailComponent } from './motor-detail/motor-detail.component';
import { InsuranceCompareComponent } from './insurance-compare/insurance-compare.component';
import { PaymentDetailComponent } from './payment-detail/payment-detail.component';
import { PaymentSummaryComponent } from './payment-summary/payment-summary.component';
import { PaymentCallbackComponent } from './payment-callback/payment-callback.component';
import { QrBarcodeComponent } from './qr-barcode/qr-barcode.component';
import { LoaderComponent } from './loader/loader.component';
import { NonMotorDetailComponent } from './nonmotor-detail/nonmotor-detail.component';
import { NonMotorStepComponent } from './nonmotor-step/nonmotor-step.component';

import { NgCircleProgressModule } from 'ng-circle-progress';


import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { AutocompleteLibModule} from 'angular-ng-autocomplete';
import { PageErrorComponent } from './page-error/page-error.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { TiscoModalComponent } from '../shared/component/tisco-modal/tisco-modal.component';
import { AppComponent } from '../app.component';
import { CircleProgressComponent } from './circle-progress/circle-progress.component';

@NgModule({
  declarations: [RenewalComponent, MotorStepComponent, MotorDetailComponent, PaymentDetailComponent, InsuranceCompareComponent, LoaderComponent, PaymentSummaryComponent, PaymentCallbackComponent, QrBarcodeComponent, NonMotorDetailComponent, NonMotorStepComponent, PageErrorComponent],
  imports: [
    CommonModule,
    RenewalRoutingModule,
    FormsModule,
    SharedModule,
    CircleProgressComponent,
    NgxDaterangepickerMd.forRoot(),
    AutocompleteLibModule,
    NgxMaskDirective, NgxMaskPipe,
  ],
  providers:[
    provideNgxMask()
  ],
  exports: [
    
    RenewalComponent,
    PaymentDetailComponent
  ]
})
export class RenewalModule { }
